<!-- footer Start -->
<section class="footer">
    <div class="container">
        <div class="row">
            <div class="col-lg-4">
                <div class="mb-4">
                    <a href="layout-one"><img src="assets/logos/aa.png" alt="" class="logo-dark" height="26" /></a>
                    <ul class="list-unstyled company-sub-menu">
                        <li><a href="mailto:info@argoapps.com" class="text-muted font-weight-normal"><u>info@argoapps.com</u></a></li>
                        <li><a href="tel:+50664845946" class="text-muted font-weight-normal">+506 6484-5946</a></li>
                    </ul>
                    <ul class="list-unstyled footer-social-list mt-4">
                        <li class="list-inline-item"><a href="https://api.whatsapp.com/send?phone=50664845946&text=Buenas%20tardes%20requiero%20información" target="_blank"><i class="mdi mdi-whatsapp"></i></a></li>
                        <li class="list-inline-item"><a href="https://t.me/+50664845946" target="_blank"><i class="mdi mdi-telegram"></i></a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-8">
                <div class="row">
                    <div class="col-md-4">
                        <h6 class="footer-list-title text-dark mb-3">Servicios</h6>
                        <ul class="list-unstyled company-sub-menu">
                            <li><a>Desarrollo Web</a></li>
                            <li><a>Aplicaciones de Escritorio</a></li>
                            <li><a>Aplicaciones Móviles</a></li>
                            <li><a>E-commerce</a></li>
                            <li><a>Análisis de entorno</a></li>
                        </ul>
                    </div>
                    <div class="col-md-4">
                        <h6 class="footer-list-title text-dark mb-3">Acerca de Nosotross</h6>
                        <ul class="list-unstyled company-sub-menu">
                            <li><a [ngxScrollTo]="'#contac'" href="javascript: void(0);" [ngxScrollToOffset]="2">Contactanos</a></li>
                            <li><a>Politicas de Privacidad</a></li>
                        </ul>
                    </div>
                    <div class="col-md-4">
                        <h6 class="footer-list-title text-dark mb-3">Dirección</h6>
                        <p class="text-muted f-14">Diagonal 33A Guadalupe, Goicoechea, San Jose, Costa Rica</p>

                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-5">
            <div class="col-md-12">
                <div class="text-center text-muted">
                    <p class="mb-0 f-15"> {{currentYear}} © ArgoApps. Design by ArgoApps</p>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- footer End -->